import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { CasinoRetriever, CasinoWidget, getGameRowUrl, LegacyCasinoRetriever, NextCasinoRetriever, pageInfoFromUrl, useCasinoPageInfo, useCasinoProviders, useCasinoSlots, useFilteredGamesList, useGamesRow } from "../../desktop-components/casino/logic";

import { CasinoSearchPopup } from "../casino";
import { CasinoPagesInfo, InfiniteScrollPage } from "../../desktop-components/casino/casino-components";
import { useMemo, useState } from "preact/hooks";
import Session from "../../utils/session";
import { Component } from "preact";
import PageDataFeed from "../../../../services/page-data-feed";
import { GameEntry } from "../../../../services/casino-feed";

import * as I from "../../utils/icons";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import Config from "../../config";
import { route } from "preact-router";

export function MobileCasinoMultiPage({ path, type, pageCode }) {
    if (path == '/casino') {
        route('/virtual');
        return;
    }
    const pagesInfo = useCasinoPageInfo()
    if (pagesInfo == null)
        return null;
    const slots = useCasinoProviders();
    const gamesRetriever = useMemo(() => new NextCasinoRetriever(slots), [slots]);
    const mainPage = path.split('/')[1];
    const pageTypeInfo = pagesInfo.getPage(mainPage);

    return <div class="flex">
        {type == null
            ? <MobileWidgets key={path} mainPage={mainPage} page={pageTypeInfo.rows} games={gamesRetriever} />
            : <InfiniteScrollPage key={path} games={gamesRetriever} currentPage={pageInfoFromUrl(type, pageCode, pagesInfo)} mainPage={mainPage} />}
        <CasinoSearchPopup />
    </div>
}

export function useFeaturedGames() {
    const pagesInfo = useCasinoPageInfo()
    if (pagesInfo == null)
        return null;
    const slots = useCasinoProviders();
    const gamesRetriever = useMemo(() => new NextCasinoRetriever(slots), [slots]);
    const pageTypeInfo = pagesInfo.getPage("virtual");
    const widget = pageTypeInfo.rows.filter(row => row.type == "category")[0]
    return useFilteredGamesList(widget, gamesRetriever)
}

export function OpenSearchPageButton() {
    return (
        <div class="bg-harif-900 text-white flex h-12 items-center justify-between text-base" onClick={() => (window.location.hash = CasinoSearchPopup.CASINO_SEARCH_HASH)}>
            <div class="flex gap-2 h-full items-center px-3 text-white">
                <div class="flex h-full items-center py-3">
                    <I.SearchIcon />
                </div>
                <span><Trans>Search for a game!</Trans></span>
            </div>
            <div class="flex h-full items-center justify-center aspect-square border-l border-harif-950 text-white"><I.FilterIcon class="h-6" /></div>
        </div>
    );
}

export function MobileWidgets({ page, games, mainPage }: { page: CasinoWidget[], games: CasinoRetriever, mainPage: string }) {
    return <div class="main-content">
        <Carousel />
        <OpenSearchPageButton />
        {page.map(widget => <MobileGamesRow page={widget} games={games} mainPage={mainPage} />)}
    </div>;
}


export function MobileGamesRow({ page, games, mainPage }: { page: CasinoWidget, games: CasinoRetriever, mainPage: string }) {
    const cols = page.data.rows < 3 ? 2 : 3;
    const { scrollPrev, scrollNext, emblaRef, chunkedGames } = useGamesRow(cols, page.data.rows, games, page);
    const url = getGameRowUrl(page, mainPage);

    if (chunkedGames.length == 0)
        return null;

    return <div class="pb-4">
        <div class="flex items-center justify-between px-4 py-4 pt-2">
            <a href={url} class="text-lg">{page.data.name}</a>
            <div class="flex items-center gap-2">
                <a href={url} class="text-sm text-custom-orange"><Trans>See More</Trans></a>
                <button onClick={scrollPrev} class="w-8 h-8 rounded-full bg-harif-900 flex items-center justify-center">
                    <I.AnglesLeft class="h-4" />
                </button>
                <button onClick={scrollNext} class="w-8 h-8 rounded-full bg-harif-900 flex items-center justify-center">
                    <I.AnglesRight class="h-4" />
                </button>
            </div>
        </div>
        <div class="overflow-hidden" ref={emblaRef}>
            <div class="flex">
                {chunkedGames.map((chunk, i) => (
                    <div class="shrink-0 w-full min-w-0 px-2" key={i}>
                        <div class={`grid grid-cols-${cols} gap-2`}>
                            {chunk.map(game => <GameIcon game={game} />)}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>;
}

export class GameIcon extends Component<{game: GameEntry}> {
    private openGame(game: GameEntry) {
        if (Session.isActive())
            return PageDataFeed.setCurrentGame(game);
        location.hash = "#login";
    }
    private getImgUrl(imgUrl: string) {
        if (!imgUrl || imgUrl.indexOf("://") < 0) {
            return imgUrl;
        }
        return "https://img-res.ltngame.tools/unsafe/300x0/" + encodeURIComponent(imgUrl.replace(/https?:\/\//, ""));
    }
    render({ game }) {
        return (
            <a key={[game.provider, game.brand, game.id].join("")} class="flex aspect-square flex-col gap-0.5 pb-1" href="javascript:void(0);" onClick={e => this.openGame(game)}>
                <img class="w-full rounded-lg grow shrink object-cover object-center bg-blue-whale-700 h-0 min-h-12.5" src={this.getImgUrl(game.logo)} loading="lazy" />
                <div class="text-xs truncate">{game.name}</div>
            </a>
        );
    }
}

class Carousel extends Component {
    state = { slides: null }
    componentWillMount() {
        PageDataFeed.getCarousel().then(data => {
            this.setState({ slides: data['casino-promo'] })
        })
    }
    render() {
        if (this.state.slides == null)
            return;

        const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: 'start' }, [Autoplay()])

        return (
            <div class="h-32 w-full overflow-x-hidden">
                <div class="embla h-full" ref={emblaRef}>
                    <div class="embla__container h-full will-change-transform">
                        {this.state.slides.map(slide => (<div class="grow-0 shrink-0 w-full">
                            <div class="relative h-full w-full">
                                <div class="h-full w-full shrink-0 bg-cover bg-left" style={"background-image:url('" + (Config.softionAPI + slide.img) + "')"}></div>
                                {!!slide.title && <div class="absolute w-1/2 top-0 bottom-0 right-0 bg-linear-to-r from-black/0 via-black/80 to-black">
                                    <div class="absolute top-1/2 -translate-y-1/2 text-white drop-shadow-xl text-sm right-1">
                                        <div class="text-sm drop-shadow">{slide.title}</div>
                                        <div class="text-xs drop-shadow">{slide.subtitle}</div>
                                    </div>
                                </div>}
                            </div>
                        </div>))}
                    </div>
                </div>
            </div>
        )
    }
}